import Separator from "core/components/Separator";
import { motion } from "framer-motion";
import useIsMobile from "hooks/useIsMobile";

interface CardSomatorioProps {
	numeroEmbarque: string;
	somatorioFreteFiscal: string;
	somatorioFreteMotorista: string;
	somatorioIcms: string;
	somatorioKm: string;
	somatorioExcedeuPisoAntt: string;
	somatorioMargem: string;
	show: boolean;
	recalcTableHeight: () => void;
}

function CardSomatorio({
	numeroEmbarque,
	somatorioIcms,
	somatorioKm,
	somatorioExcedeuPisoAntt,
	somatorioMargem,
	somatorioFreteFiscal,
	somatorioFreteMotorista,
	show,
	recalcTableHeight,
}: CardSomatorioProps) {
	const isMobile = useIsMobile(880);
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				width: "90%",
			}}
		>
			<motion.div
				initial={{
					opacity: 0,
					height: 0,
				}}
				animate={{
					opacity: show ? 1 : 0,
					height: show ? (isMobile ? 110 : 100) : 0,
				}}
				onAnimationComplete={() => {
					requestAnimationFrame(() => {
						recalcTableHeight();
					});
				}}
				className="container-somatorio-card"
			>
				<div className="card-faturamento">
					<div className="card-header">Número de Viagens</div>
					<div className="card-body">{numeroEmbarque}</div>
				</div>
				<div className="card-faturamento">
					<div className="card-header">Somatório Frete Fiscal</div>
					<div className="card-body">{somatorioFreteFiscal}</div>
				</div>
				<div className="card-faturamento">
					<div className="card-header">Somatório Freta Motorista</div>
					<div className="card-body">{somatorioFreteMotorista}</div>
				</div>
				<div className="card-faturamento">
					<div className="card-header">Somatório Icms</div>
					<div className="card-body">{somatorioIcms}</div>
				</div>
				<div className="card-faturamento">
					<div className="card-header">Somatório KM</div>
					<div className="card-body">{somatorioKm}</div>
				</div>
				<div className="card-faturamento">
					<div className="card-header">Soma Piso ANTT</div>
					<div className="card-body">{somatorioExcedeuPisoAntt}</div>
				</div>
				<div className="card-faturamento">
					<div className="card-header">Margem</div>
					<div className="card-body">{somatorioMargem}</div>
				</div>
			</motion.div>
			<Separator size={isMobile ? "lg" : "xs"} />
		</div>
	);
}

export default CardSomatorio;
